"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const ts_interface_checker_1 = require("ts-interface-checker");
const types = require("./types-ti");
const checkers = (0, ts_interface_checker_1.createCheckers)(types.default);
function check(instance, interfaceName) {
  let path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '[request-body]';
  checkers[interfaceName].setReportedPath(path);
  checkers[interfaceName].check(instance);
}
exports.default = check;